<div class="w-12 bg-col-w height-100 flex flex-column flex-middle flex-justify-center p-a-8 p-a-4-m p-a-4-s">
    <p class="h2 center">{{'Sorry!' | translate}}</p>
    <p class="p1 m-t-6 center">
        {{'You don’t have access to this product type, please contact your business representative.' | translate}}
    </p>
    <button class="w-12 button m-t p1"
            (click)="goBack()">{{'Go back' | translate}}</button>
</div>